// extracted by mini-css-extract-plugin
module.exports = {"title":"SectionTitle_title__1Knrs","title__bigger":"SectionTitle_title__bigger__fMu0B"};